import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PageHeader from '../../components/PageHeader.jsx';
import Loader, { ErrorBox } from '../../components/Loader.jsx';
import ComplaintForm from './ComplaintForm.jsx';
import { ComplaintsAPI } from '../../lib/api';
import { complaintSerial } from '../../lib/complaintSerial';
import { useAuth } from '../../lib/auth.jsx';
import { buildPath, complaintCapabilities } from '../../config';

export default function ComplaintEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const can = complaintCapabilities(user);


  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // Hiding the Edit links isn't enough — an external user could still
  // type /complaints/:id/edit.  Bounce them to the read-only detail
  // view rather than render a form whose PATCH the API would reject.
  useEffect(() => {
    if (!can.canEdit) navigate(buildPath.complaintDetails(id), { replace: true });
  }, [can.canEdit, id, navigate]);

  useEffect(() => {
    if (!can.canEdit) return;
    ComplaintsAPI.retrieve(id)
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [id, can.canEdit]);


  const onSubmit = async (payload) => {
    setSubmitting(true);
    setError(null);
    try {
      // FormData (file upload) -> use POST/PATCH manually via update; otherwise PATCH JSON.
      await ComplaintsAPI.update(id, payload);
      navigate(buildPath.complaintDetails(id));
    } catch (e) {
      setError(e);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Loader />;
  if (!data) return <ErrorBox error={error || new Error('Complaint not found.')} />;

  return (
    <>
      <PageHeader title={`Edit Complaint #${complaintSerial(data)}`} />
      <ErrorBox error={error} />
      <ComplaintForm
        initial={{
          complaint_title:      data.complaint_title || '',
          description:          data.description || '',
          divisions:            data.divisions || '',
          sub_divisions:        data.sub_divisions || '',
          assign_to:            data.assign_to || '',
          assign_to_email:      data.assign_to_email || '',
          status:               data.status || 'pending',
          fullname:             data.fullname || '',
          mobile_number:        data.mobile_number || '',
          email:                data.email || '',
          registeration_number: data.registeration_number || '',
        }}
        onSubmit={onSubmit}
        submitting={submitting}
        mode="edit"
      />
    </>
  );
}
